/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInlineMessage} from '../api'

 export const useQueryGetInlineMessage = createReactQueryHook('getInlineMessage', getInlineMessage)
